import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import Desktop from './Desktop';
import Mobile from './Mobile';
import { skipZipcode, addZipcode } from '../../../../actions/waitlist';

import '../../styles.css';


class Component extends React.Component {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
    this.update = this.update.bind(this);

    this.state = { zipcode: "" };
  }

  submit() {
    this.props.submit(this.state.zipcode, this.props.token);
    if (window._paq) {
      window._paq.push(['trackEvent', 'JoinWaitlist', 'addZipcode']);
    }
  }

  update(e) {
    this.setState({ zipcode: e.target.value });
  }

  render() {
    return (
      <div className="waitlist_inherit">
        <MediaQuery minWidth={769}>
          <Desktop update={this.update}
                   submit={this.submit}
                   skip={this.props.skip}
                   loading={this.props.loading}
                   error={this.props.error}
          />
        </MediaQuery>
        <MediaQuery maxWidth={768}>
          <Mobile update={this.update}
                  submit={this.submit}
                  skip={this.props.skip}
                  loading={this.props.loading}
                  error={this.props.error}
          />
        </MediaQuery>
      </div>
    );
  }
}


function getState(state) {
  return ({
    token: state.waitlist.token,
    loading: state.waitlist.loading,
    error: state.waitlist.error,
  });
}

function getActions(dispatch) {
  return {
    submit: (zip, token) => { dispatch(addZipcode(zip, token)) },
    skip: () => { dispatch(skipZipcode()) },
  };
}

Component.displayName = "Zipcode";

export default connect(getState, getActions)(Component);



// WEBPACK FOOTER //
// ./src/forms/JoinWaitlist/components/Zipcode/index.js